module.exports = "/_next/static/media/46004cac18f90168d6d45bea31696333.svg";